import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Container, Table, Badge } from 'react-bootstrap'
import { fetchBreakdownTickets, fetchBreakdownTicketsSummary } from '../../../store/actions/breakdownTickets'
import Loader from '../../helpers/hoc/loader/Loader'
import NoRecordFound from '../../helpers/hoc/noRecordFound'

const BreakdownTicketsReport = () => {
  const dispatch = useDispatch()
  const tickets = useSelector(state => state.breakdownTickets.tickets)
  const summary = useSelector(state => state.breakdownTickets.summary)
  const [isLoading, setIsLoading] = useState(false)
  const [filterType, setFilterType] = useState('all')

  useEffect(() => {
    const loadData = async () => {
      setIsLoading(true)
      await Promise.all([
        dispatch(fetchBreakdownTickets()),
        dispatch(fetchBreakdownTicketsSummary())
      ])
      setIsLoading(false)
    }
    loadData()
  }, [dispatch])

  const handleFilterChange = async (type) => {
    setFilterType(type)
    setIsLoading(true)
    await dispatch(fetchBreakdownTickets({ type: type === 'all' ? undefined : type }))
    setIsLoading(false)
  }

  return (
    <Container fluid>
      <div className='py-3'>
        <div className='d-flex gap-3 mb-3 align-items-center'>
          <div className='d-flex gap-2'>
            <button
              className={`btn btn-sm ${filterType === 'all' ? 'btn-primary' : 'btn-outline-primary'}`}
              onClick={() => handleFilterChange('all')}
            >
              All ({summary?.totalTickets || 0})
            </button>
            <button
              className={`btn btn-sm ${filterType === 'accident' ? 'btn-danger' : 'btn-outline-danger'}`}
              onClick={() => handleFilterChange('accident')}
            >
              Accident ({summary?.accidentTickets || 0})
            </button>
            <button
              className={`btn btn-sm ${filterType === 'breakdown' ? 'btn-warning' : 'btn-outline-warning'}`}
              onClick={() => handleFilterChange('breakdown')}
            >
              Breakdown ({summary?.breakdownTickets || 0})
            </button>
          </div>
          <div className='d-flex gap-3 ms-auto'>
            <span className='text-muted' style={{ fontSize: '13px' }}>
              Accident Vehicles: <strong>{summary?.accidentVehicleCount || 0}</strong>
            </span>
            <span className='text-muted' style={{ fontSize: '13px' }}>
              Breakdown Vehicles: <strong>{summary?.breakdownVehicleCount || 0}</strong>
            </span>
          </div>
        </div>

        {!tickets?.length && !isLoading ? (
          <NoRecordFound />
        ) : (
          <Table responsive bordered hover size='sm' className='mt-2'>
            <thead>
              <tr style={{ fontSize: '12px', background: '#EFF3F8', color: '#1F2A5D' }}>
                <th>S.No</th>
                <th>Ticket ID</th>
                <th>Vehicle No.</th>
                <th>Type</th>
                <th>Status</th>
                <th>Description</th>
                <th>Location</th>
                <th>Driver Name</th>
                <th>Driver Contact</th>
                <th>Created Date</th>
                <th>Closed Date</th>
                <th>Remarks</th>
              </tr>
            </thead>
            <tbody>
              {tickets?.map((ticket, index) => (
                <tr key={ticket.ticketId || index} style={{ fontSize: '12px' }}>
                  <td>{index + 1}</td>
                  <td>{ticket.ticketId}</td>
                  <td>{ticket.registrationNumber}</td>
                  <td>
                    <Badge bg={ticket.isAccident ? 'danger' : 'warning'} text={ticket.isAccident ? 'white' : 'dark'}>
                      {ticket.type}
                    </Badge>
                  </td>
                  <td>{ticket.status}</td>
                  <td style={{ maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{ticket.description}</td>
                  <td>{ticket.location}</td>
                  <td>{ticket.driverName}</td>
                  <td>{ticket.driverContact}</td>
                  <td>{ticket.createdDate}</td>
                  <td>{ticket.closedDate}</td>
                  <td style={{ maxWidth: '150px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{ticket.remarks}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </div>
      <Loader isLoading={isLoading} />
    </Container>
  )
}

export default BreakdownTicketsReport
